import Vue from 'vue'
import VueLocalforage from 'v-localforage'

Vue.use(VueLocalforage, {"name":"eprin","storeName":"eprin","driver":"asyncStorage","version":1})

export default (ctx, inject) => {
  inject('localForage', Vue.$localforage)
}
